<template>
  <div>
    <p>
      {{ $t('sureConnected') }}
      {{ $t('goToStart') }} <mdicon name="windows" /> → {{ $t('parameters') }}  <img v-if="image" :src="image" style="width:3%;height:2%;" class="error-image" alt=""> → {{ $t('privacy') }} <mdicon name="lock-outline" /> → {{ $t('mic') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }}
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }}
      </li>
      <li>
        {{ $t('p4') }}
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://support.microsoft.com/windows/a83257bc-e990-d54a-d212-b5e41beba857">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
import { mdiLockOutline, mdiWindows } from '@mdi/js';
import cogOutlineImage from '../../../assets/img/cog-outline.png';

export default {
  name: 'NoSoundWindowsFirefox',
  computed: {
    image() {
      return cogOutlineImage;
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
sureConnected: If you are sure that your microphone is connected, the most likely issue is that access is blocked in your Windows privacy settings.
goToStart: Go to Start
parameters: Settings
privacy: Privacy
mic: 'Microphone. Make sure that:'
p1: Microphone access is enabled for this device;
p2: '"Allow applications to access microphone" is set to "On";'
p3: '"Allow desktop apps to access my microphone" (if any) is set to "On";'
p4: Refresh the page after making any changes to the settings.
more: Learn more on the
support: Microsoft Support site
</i18n>

<i18n locale="ru" lang="yaml">
sureConnected: Если вы уверены, что ваш микрофон подключен, вероятнее всего доступ к нему запрещён в настройках приватности Windows.
goToStart: Перейдите Пуск
parameters: Параметры
privacy: Конфиденциальность
mic: 'Микрофон. Убедитесь, что:'
p1: Доступ к микрофону для этого устройства включен;
p2: «Разрешить приложениям доступ к микрофону» находится в положении «Вкл.»;
p3: «Разрешить классическим приложениям доступ к микрофону» (если есть) находится в положении «Вкл.»;
p4: После внесения изменений в настройки обновите страницу.
more: Подробнее на сайте
support: поддержки Microsoft
</i18n>
